<template>
	<div>
		<LaptopJobSearch v-if="isLaptop" />
		<MobileJobSearch v-else />
	</div>
</template>

<script>
import LaptopJobSearch from "../JobSearch/LaptopJobSearch.vue";
import MobileJobSearch from "../JobSearch/MobileJobSearch.vue";

export default {
	name: "JobSearch",
	components: {
		LaptopJobSearch,
		MobileJobSearch,
	},
	data() {
		return {
			isLaptop: true,
		};
	},
	created() {
		this.checkScreenSize(); // Check screen size initially

		window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
	},
};
</script>

<style></style>
